// SPDX-License-Identifier: AGPL-3.0-or-later

export function resolveNotifyReactionsNotifiedMessages(
	channelValue: boolean | null | undefined,
	categoryValue: boolean | null | undefined,
	guildValue: boolean | null | undefined,
	accountDefault: boolean,
): boolean {
	if (typeof channelValue === 'boolean') return channelValue;
	if (typeof categoryValue === 'boolean') return categoryValue;
	if (typeof guildValue === 'boolean') return guildValue;
	return accountDefault;
}
